import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import uuid from "react-uuid";
import { makeStyles, withStyles } from "@mui/styles";
import {
  CustomSelect,
  CustomSelectUUID,
  TextInput,
  FloatInput,
  IntInput,
} from "components/Input/Index.js";
import AutocompleteMultiselectInput from "components/Input/AutocompleteMultiselectInput.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import DateInput from "components/Input/DateInput.js";
import Button from "@mui/material/Button";
import { batiment } from "variables/patrimoine.js";
import { walltype } from "variables/lists/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { getFiles, getSite } from "services/ConfigServices";
import { NotificationManager } from 'react-notifications';

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

function EditWallDialog(props) {
  const [value, setValue] = useState("0");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };
  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const {
    closeModal,
    refetch,
    idSelected,
    prevWallList,
    materialList,
    name,
    clef,
    type,
    materials,
    length,
    width,
    surface,
    thickness,
    thicknessprecision,
    walldependency,
    deperdition,
    uponderation,
    uwall,
    thermicalresistance,
    deperditionpart,
    wallorientation,
    rooftilt,
    performancegrade,
    performancecomment,
    dilapidationgrade,
    dilapidationcomment,
    otherproperties,
    associatedfiles,
    comments,
    description,
    loaded,
    handleNameChange,
    handleClefChange,
    handleTypeChange,
    handleMaterialsChange,
    handleLengthChange,
    handleWidthChange,
    handleSurfaceChange,
    handleThicknessChange,
    handleThicknessprecisionChange,
    handleWalldependencyChange,
    handleDeperditionChange,
    handleUponderationChange,
    handleUwallChange,
    handleThermicalresistanceChange,
    handleDeperditionpartChange,
    handleWallorientationChange,
    handleRooftiltChange,
    handlePerformancegradeChange,
    handlePerformancecommentChange,
    handleDilapidationgradeChange,
    handleDilapidationcommentChange,
    handleOtherpropertiesChange,
    handleAssociatedfilesChange,
    handleCommentsChange,
    handleDescriptionChange,
  } = props;

  const handleSubmit = async (event) => {
    const indexToReplace = prevWallList.findIndex(
      (x) => x.uuid === idSelected
    );

    const editedWall = {
      name,
      clef,
      type,
      materials,
      length,
      width,
      surface,
      thickness,
      thicknessprecision,
      walldependency,
      deperdition,
      uponderation,
      uwall,
      thermicalresistance,
      deperditionpart,
      wallorientation,
      rooftilt,
      comments,
      performancegrade,
      performancecomment,
      dilapidationgrade,
      dilapidationcomment,
      otherproperties,
      associatedfiles,
      comments,
      description,
      'uuid': idSelected,
    };

    const walllist = prevWallList;
    walllist.splice(indexToReplace, 1, editedWall);

    axios
      .put(
        getSite(chartIdGroup, "structure.walls.walls"),
        walllist,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Cloison modifiée");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        closeModal();
        refetch();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const autocompleteOptions = [];

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={batiment.structure.walls.walls.key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={batiment.structure.walls.walls.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={batiment.structure.walls.walls.type}
                textInput={type}
                handleTextInputChange={handleTypeChange}
              />
            </div>
            <div>
              <IntInput
                inputTitle={batiment.structure.walls.walls.length}
                intInput={length}
                handleIntInputChange={handleLengthChange}
              />
            </div>
            <div>
              <IntInput
                inputTitle={batiment.structure.walls.walls.width}
                intInput={width}
                handleIntInputChange={handleWidthChange}
              />
            </div>
            <div>
              <IntInput
                inputTitle={batiment.structure.walls.walls.surface}
                intInput={surface}
                handleIntInputChange={handleSurfaceChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={batiment.structure.walls.walls.thickness}
                floatInput={thickness}
                handleFloatInputChange={handleThicknessChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={batiment.structure.walls.walls.thicknessprecision}
                floatInput={thicknessprecision}
                handleFloatInputChange={handleThicknessprecisionChange}
              />
            </div>
            <div>
              <CustomSelectUUID
                inputTitle={batiment.structure.walls.walls.walldependency}
                selectValue={walldependency}
                handleSelectValueChange={handleWalldependencyChange}
                data={prevWallList}
              />
            </div>
            <div style={{ width: "98%" }}>
              <AutocompleteMultiselectInput
                inputTitle={batiment.structure.walls.walls.materials}
                selected={Array.isArray(materials) ? materials : []}
                list={materialList}
                handleChange={handleMaterialsChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={batiment.structure.walls.walls.deperdition}
                floatInput={deperdition}
                handleFloatInputChange={handleDeperditionChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={batiment.structure.walls.walls.uponderation}
                floatInput={uponderation}
                handleFloatInputChange={handleUponderationChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={batiment.structure.walls.walls.thermicalresistance}
                floatInput={thermicalresistance}
                handleFloatInputChange={handleThermicalresistanceChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={batiment.structure.walls.walls.uwall}
                floatInput={uwall}
                handleFloatInputChange={handleUwallChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={batiment.structure.walls.walls.deperditionpart}
                floatInput={deperditionpart}
                handleFloatInputChange={handleDeperditionpartChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={batiment.structure.walls.walls.wallorientation}
                textInput={wallorientation}
                handleTextInputChange={handleWallorientationChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={batiment.structure.walls.walls.rooftilt}
                floatInput={rooftilt}
                handleFloatInputChange={handleRooftiltChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={batiment.structure.walls.walls.performancegrade}
                textInput={performancegrade}
                handleTextInputChange={handlePerformancegradeChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={batiment.structure.walls.walls.performancecomment}
                textInput={performancecomment}
                handleTextInputChange={handlePerformancecommentChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={batiment.structure.walls.walls.dilapidationgrade}
                textInput={dilapidationgrade}
                handleTextInputChange={handleDilapidationgradeChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={batiment.structure.walls.walls.dilapidationcomment}
                textInput={dilapidationcomment}
                handleTextInputChange={handleDilapidationcommentChange}
              />
            </div>

            <div>
              <AutocompleteTagsInput
                inputTitle={batiment.structure.walls.walls.otherproperties}
                list={autocompleteOptions}
                selected={otherproperties}
                handleChange={handleOtherpropertiesChange}
              />
            </div>
            <div style={{ width: "98%" }}>
              <AutocompleteInput
                inputTitle={batiment.structure.walls.walls.associatedfiles}
                selected={selectedGed()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
              />
            </div>
            <div>
              <TextInput
                inputTitle={batiment.structure.walls.walls.comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={batiment.structure.walls.walls.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              noWrap
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "0px",
                marginBottom: "0px",
                marginTop: "15px",
                fontFamily: '"Source Sans Pro",sans-serif',
                width: "96%",
                marginLeft: "2%",
              }}
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default EditWallDialog;
